import type { TemplateResponseFormDTO } from '@conversed/rest/src/contracts/template-response/template-response.dto';
import type React from 'react';
import { useTemplateResponseActions } from '../../../../hooks/settings/template-response/useTemplateResponseActions';
import { useTemplateResponses } from '../../../../hooks/settings/template-response/useTemplateResponses';
import { TemplateResponseDataModal } from './TemplateResponseDataModal';

export const EditTemplateResponseModal: React.FC = () => {
  const { updateTemplateResponse } = useTemplateResponseActions();
  const { selectedTemplateResponse } = useTemplateResponses();

  const onSubmit = async (templateResponseData: TemplateResponseFormDTO) => {
    if (selectedTemplateResponse?._id) {
      updateTemplateResponse(
        selectedTemplateResponse._id.toString(),
        templateResponseData,
      );
    }
  };

  return (
    <TemplateResponseDataModal
      onSubmit={onSubmit}
      templateResponseData={{
        name: selectedTemplateResponse?.name,
        content: selectedTemplateResponse?.content,
        url: selectedTemplateResponse?.url || '',
      }}
    />
  );
};

export default EditTemplateResponseModal;
